

    import { defineComponent } from 'vue'

    export default defineComponent({
        name: 'DownCaret',
        props: {
            upwards: {
                type: Boolean, default: false
            }
        }
    })

